import { salesTrafficResponseSchema } from "@adpilot/shared";
import { type ReportingPeriod, reportingPeriodSearchParams } from "@/stores/reporting-period";
import { api } from "./api";
import type { ReportingTimeZone } from "./reporting-time-zone";

export async function fetchSalesTraffic(
  params: {
    range: ReportingPeriod;
    timeZone: ReportingTimeZone;
    shopIds?: string[];
    asins?: string[];
  },
  signal?: AbortSignal,
) {
  const response = await api
    .get("dashboard/sales-traffic", {
      signal,
      searchParams: {
        ...reportingPeriodSearchParams(params.range, params.timeZone),
        ...(params.shopIds?.length ? { shopIds: params.shopIds.join(",") } : {}),
        ...(params.asins?.length ? { asins: params.asins.join(",") } : {}),
      },
    })
    .json<{ success: true; data: unknown }>();
  return salesTrafficResponseSchema.parse(response.data);
}
